// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ju-z","tooltipWrapper":"ku-z","icon":"lu-z","tooltip":"mu-z","content":"nu-z"};